import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from "react-router-dom";

import Header from "./components/Header";
import Banner from "./components/Banner";
import Services from "./components/Services";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import HappiestCustomerSlider from "./components/HappiestCustomerSlider";
import CallChatSection from "./components/CallChatSection";


import Contact  from "./components/Contact";
import ScrollProgress from "./components/ScrollProgress";


// Admin components
import Login from "./admin/Login";
import Dashboard from "./admin/Dashboard";
import BannerForm from "./admin/BannerForm";
import BannerList from "./admin/BannerList";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  const [admin, setAdmin] = useState(false);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogin = (username) => {
    setAdmin(username);
  };

  const handleLogout = () => {
    setAdmin(false);
  };

  return (
    <Router>
      <Routes>
        {/* Public site */}
        <Route
          path="/"
          element={
            <>
              <Header />
              <Banner />
              <Services />
              <About />
            
              <Gallery />
             <HappiestCustomerSlider/>
              <CallChatSection />
              <Contact />
               <WhatsAppButton />
              <Footer />
               <ScrollProgress />
            </>
          }
        />

        {/* Admin routes */}
        <Route path="/admin/login" element={<Login onLogin={handleLogin} />} />
        <Route
          path="/admin/dashboard"
          element={
            admin ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          }
        />
        <Route
          path="/admin/banners"
          element={admin ? <BannerList /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/banners/add"
          element={admin ? <BannerForm /> : <Navigate to="/admin/login" />}
        />

        {/* Redirect unknown routes */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
